import React from "react";
import { Link } from "react-router-dom";
import { compose, withAppContext, withActions } from "containers/HOC";
import * as icons from "common/icons";
import { fetchFarm } from "containers/Farm/_actions";
import RenewSubscriptionButton from "containers/Payments/RenewSubscriptionButton";
import Breadcrumb from "components/Breadcrumb/Breadcrumb";

const FarmPageHead = ({ farm = {}, title, fetchFarm, breadcrumb }) => {
    return (
        <>
            <section className="PageHead">
                <div className="Container BudgetHeader">
                    <div className="FarmTitle">
                        <Link to={`/app/farm/${farm.id}`}>
                            <img className="FarmTitle-icon FarmTitle-icon--lg" src={icons.farm} alt="Farm icon" />
                        </Link>
                        <div className="FarmTitle-heading FarmTitle-heading--lg">
                            <Link to={`/app/farm/${farm.id}`}>
                                <span id="page-head-title" className="FarmTitle-name" title={farm.name}>
                                    {farm.name}
                                </span>
                            </Link>
                            <div id="page-head-sub-title" className="FarmTitle-sub" title={farm.address}>
                                {farm.address}
                            </div>
                        </div>
                    </div>

                    <div className="PageHead-budgetOverview u-print-none u-mr-sm" title={title}>
                        {title}
                    </div>

                    <RenewSubscriptionButton farm={farm} onPaid={() => fetchFarm(farm.id, true)} />

                    <div className="PageHead-PrintLogo">
                        <img src={icons.logoPrint()} alt="logo" style={{ width: "200px", height: "50px" }} />
                    </div>
                </div>
            </section>
            {breadcrumb && breadcrumb.length > 0 && <Breadcrumb breadcrumb={breadcrumb} />}
        </>
    );
};

export default compose(withAppContext, withActions({ fetchFarm }))(FarmPageHead);
